import { render } from "./CajaDetalle.vue?vue&type=template&id=51d2f194&scoped=true"
import script from "./CajaDetalle.vue?vue&type=script&lang=js"
export * from "./CajaDetalle.vue?vue&type=script&lang=js"

import "./CajaDetalle.vue?vue&type=style&index=0&id=51d2f194&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d2f194"]])

export default __exports__